import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorFlagTitle: {
		id: 'eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title',
		defaultMessage: 'Something went wrong while updating user properties.',
		description: 'Helper text for updating user properties error flag',
	},
});
export default messages;
